import {
  LogIn, UserPlus, Target, Brain, Bot, Zap,
} from 'lucide-react';

export const ACTION_CONFIG = {
  login: { label: 'Inicio de Sesion', icon: LogIn, color: 'text-blue-400', bg: 'bg-blue-500/20' },
  register: { label: 'Nuevo Registro', icon: UserPlus, color: 'text-emerald-400', bg: 'bg-emerald-500/20' },
  recommendation: { label: 'Recomendacion', icon: Target, color: 'text-green-400', bg: 'bg-green-500/20' },
  super_ia: { label: 'Sócrates', icon: Brain, color: 'text-purple-400', bg: 'bg-purple-500/20' },
  bot_diario: { label: 'Bot Diario', icon: Bot, color: 'text-amber-400', bg: 'bg-amber-500/20' },
  prediction: { label: 'Prediccion', icon: Zap, color: 'text-cyan-400', bg: 'bg-cyan-500/20' },
  aries: { label: 'Aries', icon: Zap, color: 'text-orange-400', bg: 'bg-orange-500/20' },
};

export const playAlertSound = (type = 'default') => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    gain.gain.value = 0.15;
    if (type === 'register') {
      osc.frequency.setValueAtTime(523, ctx.currentTime);
      osc.frequency.linearRampToValueAtTime(784, ctx.currentTime + 0.15);
      osc.frequency.linearRampToValueAtTime(1047, ctx.currentTime + 0.3);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.5);
    } else if (type === 'prediction') {
      osc.frequency.setValueAtTime(880, ctx.currentTime);
      gain.gain.setValueAtTime(0.15, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.1);
      gain.gain.setValueAtTime(0.15, ctx.currentTime + 0.15);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.35);
    } else {
      osc.frequency.setValueAtTime(660, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.25);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.3);
    }
  } catch (e) { /* Audio not supported */ }
};

export const formatRelativeTime = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  if (diffMin < 1) return 'Ahora mismo';
  if (diffMin < 60) return `Hace ${diffMin} min`;
  if (diffHours < 24) return `Hace ${diffHours}h`;
  if (diffDays < 7) return `Hace ${diffDays}d`;
  return date.toLocaleDateString('es-DO', { day: '2-digit', month: 'short' });
};

export const formatFullDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('es-DO', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
};

export const getDeviceType = (ua) => {
  if (!ua) return 'desktop';
  const lower = ua.toLowerCase();
  if (lower.includes('mobile') || lower.includes('android') || lower.includes('iphone')) return 'mobile';
  return 'desktop';
};
